module.exports = __webpack_public_path__ + "img/Zain-Jordan-En.d7ee19cf.jpg";